import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import Image from 'next/image';
import Header from '../components/Header';

export default function ServicesPage() {
  const phoneNumber = "(630) 715-8829";
  const companyName = "Partners Plumbing Co.";
  const serviceArea = "Kane County, Illinois";
  const address = "Kane County, IL 60177";
  const email = "info@partnersinplumbing.com";

  return (
    <>
      <Head>
        <title>{`Plumbing Services Kane County IL | Geneva, St Charles Plumber | ${companyName}`}</title>
        <meta name="description" content={`Plumbing services near me in Kane County, Geneva, St Charles & South Elgin, IL. Emergency plumber, drain cleaning, water heater repair, sewer repair. Licensed plumber. Call ${phoneNumber}`} />
        <meta name="keywords" content="plumbing services near me, plumbing services Kane County, emergency plumber Geneva IL, drain cleaning near me, water heater repair near me, sewer repair near me, plumber St Charles IL, plumbing contractor Kane County" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://partnersinplumbing.com/services" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="min-h-screen bg-white font-inter">
        <Header currentPage="/services" phoneNumber={phoneNumber} companyName={companyName} />

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-900 text-white py-12 md:py-20 relative overflow-hidden">
          <div className="absolute inset-0 bg-black opacity-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="text-center lg:text-left">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6 leading-tight">Professional Plumbing Services in Geneva, IL - Serving Kane County</h1>
                <p className="text-lg sm:text-xl mb-6 lg:mb-8 text-slate-100 leading-relaxed">
                  Local plumber near me providing emergency plumbing, drain cleaning, water heater repair, and all plumbing services throughout Geneva, St Charles, South Elgin, and Kane County, IL. Licensed plumbing contractor trusted by over 5,000 customers.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a href={`tel:${phoneNumber}`} className="bg-yellow-500 text-slate-900 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg hover:bg-yellow-400 transition-all duration-200 shadow-lg hover:shadow-xl text-center">
                    Call {phoneNumber}
                  </a>
                  <Link href="/contact" className="bg-transparent border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg hover:bg-white hover:text-slate-900 transition-all duration-200 text-center">
                    Get Free Estimate
                  </Link>
                </div>
              </div>
              <div className="hidden lg:block">
                <div className="bg-white/10 p-8 rounded-xl backdrop-blur-sm border border-white/20 shadow-2xl">
                  <h3 className="text-2xl font-bold mb-4">Complete Service Solutions</h3>
                  <p className="text-slate-100 mb-4 leading-relaxed">Professional plumbing services for residential and commercial properties throughout Kane County</p>
                  <div className="space-y-3">
                    <div className="flex items-center text-yellow-400">
                      <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                        <div className="w-4 h-4 bg-yellow-600 rounded-full"></div>
                      </div>
                      <span className="font-semibold">Licensed & Insured</span>
                    </div>
                    <div className="flex items-center text-yellow-400">
                      <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                        <div className="w-4 h-4 bg-yellow-600 rounded-full"></div>
                      </div>
                      <span className="font-semibold">Licensed & Experienced</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trust Indicators */}
        <section className="py-8 bg-gray-100 border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                             <div className="flex flex-col items-center">
                 <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mb-2">
                   <div className="w-6 h-6 bg-white rounded-full"></div>
                 </div>
                 <span className="text-sm font-semibold text-gray-800">Licensed & Insured</span>
               </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mb-2">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <span className="text-sm font-semibold text-gray-800">5000+ Customers</span>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mb-2">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <span className="text-sm font-semibold text-gray-800">Emergency Service</span>
              </div>
            </div>
          </div>
        </section>

        {/* Services Overview */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Complete Plumbing Solutions Near Me - Kane County, IL</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Searching for "plumber near me" in Geneva, St Charles, or South Elgin? Our licensed plumbing contractor provides emergency plumber services, drain cleaning, water heater repair, and all plumbing needs in Kane County, Illinois.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-50 p-6 rounded-lg text-center">
                <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-8 h-8 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Residential Plumbing</h3>
                <p className="text-gray-600">Complete plumbing services for homes and apartments throughout Kane County</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg text-center">
                <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-8 h-8 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Commercial Plumbing</h3>
                <p className="text-gray-600">Professional plumbing solutions for businesses, restaurants, and commercial properties</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg text-center">
                <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-8 h-8 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Emergency Services</h3>
                <p className="text-gray-600">Emergency plumbing services with professional response</p>
              </div>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Professional Services</h2>
              <p className="text-xl text-gray-600">Comprehensive plumbing solutions for your home and business</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "Broken Pipe Repair",
                  description: "Emergency broken pipe repair and replacement services with rapid response throughout Kane County.",
                  features: ["Emergency service", "Pipe replacement", "Leak detection", "Insurance support"],
                  pricing: "Call for emergency pricing",
                  link: "/services/broken-pipe"
                },
                {
                  title: "Leaky Pipe, Sink & Toilet Repair",
                  description: "Professional leak repair for pipes, sinks, and toilets with same-day service availability.",
                  features: ["Pipe leak repair", "Sink leak fixes", "Toilet leak repair", "Same-day service"],
                  pricing: "Starting at $95",
                  link: "/services/leaky-plumbing"
                },
                {
                  title: "Water Heater Replacement",
                  description: "Expert water heater replacement including tank, tankless, and hybrid systems with warranties.",
                  features: ["Tank & tankless units", "Energy efficient models", "Same-day installation", "10-year warranties"],
                  pricing: "Starting at $1,200",
                  link: "/services/water-heater-replacement"
                },
                {
                  title: "Reverse Osmosis Installation",
                  description: "Professional reverse osmosis system installation for pure, clean drinking water in your home.",
                  features: ["Pure drinking water", "Professional installation", "System maintenance", "Quality filtration"],
                  pricing: "Starting at $400",
                  link: "/services/reverse-osmosis"
                },
                {
                  title: "Toilet Installation & Replacement",
                  description: "Complete toilet installation and replacement services with same-day availability.",
                  features: ["New toilet installation", "Toilet replacement", "Same-day service", "All brands serviced"],
                  pricing: "Starting at $200",
                  link: "/services/toilet-installation"
                },
                {
                  title: "Emergency Water Cleanup",
                  description: "Emergency water cleanup and damage restoration services throughout Kane County.",
                  features: ["Water extraction", "Flood cleanup", "Damage assessment", "Emergency response"],
                  pricing: "Call for emergency pricing",
                  link: "/services/water-cleanup"
                },
                {
                  title: "Emergency Plumbing Service",
                  description: "Emergency plumbing services for burst pipes, major leaks, and urgent plumbing issues.",
                  features: ["Emergency availability", "Burst pipe repair", "Emergency repairs", "Fast response"],
                  pricing: "Call for emergency pricing",
                  link: "/services/emergency-plumbing-service"
                }
              ].map((service, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow">
                  <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
                      <div className="w-8 h-8 bg-white rounded-full"></div>
                    </div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                    <p className="text-gray-600 mb-4">{service.description}</p>
                  </div>
                  
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-gray-600">
                        <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                          <div className="w-2 h-2 bg-white rounded-full"></div>
                        </div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                  <div className="border-t pt-6">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-lg font-semibold text-slate-800">{service.pricing}</span>
                      <a href={`tel:${phoneNumber}`} className="text-slate-800 hover:text-slate-900 font-medium">
                        Call for Quote
                      </a>
                    </div>
                    <Link href={service.link} className="block w-full bg-slate-800 text-white text-center px-6 py-3 rounded-lg font-semibold hover:bg-slate-900 transition-colors">
                      Learn More
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Partners Plumbing Co.?</h2>
              <p className="text-xl text-gray-600">The reasons why Kane County residents trust us with their plumbing needs</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                             <div className="bg-gray-50 p-6 rounded-lg">
                 <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mb-4">
                   <div className="w-6 h-6 bg-white rounded-full"></div>
                 </div>
                 <h3 className="text-xl font-semibold text-gray-900 mb-3">Licensed & Insured</h3>
                 <p className="text-gray-600">Illinois State licensed plumbing contractor with liability insurance and workers' compensation coverage.</p>
               </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Transparent Pricing</h3>
                <p className="text-gray-600">Written estimates provided before work begins. No hidden fees, no overtime charges, no surprises.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mb-4">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">100% Satisfaction Guarantee</h3>
                <p className="text-gray-600">We stand behind our work with a complete satisfaction guarantee. If you're not happy, we'll make it right.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mb-4">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Licensed & Experienced</h3>
                <p className="text-gray-600">Serving Kane County with thousands of satisfied customers.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mb-4">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Fully Equipped Service Vehicles</h3>
                <p className="text-gray-600">Our mobile workshops carry over 1,000 parts, allowing us to complete most repairs in one visit.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-slate-600 rounded-full flex items-center justify-center mb-4">
                  <div className="w-6 h-6 bg-white rounded-full"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Local Kane County Experts</h3>
                <p className="text-gray-600">Deep knowledge of local codes and common plumbing issues in Kane County homes and businesses.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Service Areas */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Service Areas</h2>
              <p className="text-xl text-gray-600">Professional plumbing services throughout Kane County and surrounding areas</p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 text-center">
              {[
                "Kane County", "Geneva", "Saint Charles", "South Elgin"
              ].map((area, index) => (
                <div key={index} className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                  <span className="font-medium text-gray-800">{area}</span>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <p className="text-gray-600">Don't see your area? <a href={`tel:${phoneNumber}`} className="text-slate-800 hover:text-slate-900 font-medium">Call us at {phoneNumber}</a> - we may still be able to help!</p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
            <p className="text-xl mb-8 text-slate-100 max-w-2xl mx-auto">
              Contact Kane County's most trusted plumbing company today for a free estimate on any of our services. Licensed, insured, and ready to solve your plumbing problems.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={`tel:${phoneNumber}`} className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors">
                Call Now: {phoneNumber}
              </a>
              <Link href="/contact" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-slate-900 transition-colors">
                Contact Us Online
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-800 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4">{companyName}</h3>
                <p className="text-gray-300 mb-4">Professional plumbing services you can trust. Licensed, insured, and reliable serving Kane County.</p>
                <a href={`tel:${phoneNumber}`} className="text-yellow-400 font-bold text-lg hover:text-yellow-300 block mb-2">
                  {phoneNumber}
                </a>
                <a href={`mailto:${email}`} className="text-gray-300 hover:text-white block mb-2">
                  {email}
                </a>
                <p className="text-gray-300 text-sm">
                  {address}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-4">Services</h4>
                <ul className="space-y-2 text-gray-300">
                  <li><Link href="/services/broken-pipe" className="hover:text-white">Broken Pipe Repair</Link></li>
                  <li><Link href="/services/leaky-plumbing" className="hover:text-white">Leak Repair</Link></li>
                  <li><Link href="/services/water-heater-replacement" className="hover:text-white">Water Heater Replacement</Link></li>
                  <li><Link href="/services/reverse-osmosis" className="hover:text-white">Reverse Osmosis</Link></li>
                  <li><Link href="/services/toilet-installation" className="hover:text-white">Toilet Installation</Link></li>
                  <li><Link href="/services/emergency-plumbing-service" className="hover:text-white">Emergency Plumbing</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-gray-300">
                  <li><Link href="/about" className="hover:text-white">About Us</Link></li>
                  <li><Link href="/blog" className="hover:text-white">Blog</Link></li>
                  <li><Link href="/contact" className="hover:text-white">Contact</Link></li>
                  <li><Link href="/services" className="hover:text-white">All Services</Link></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2024 {companyName}. All rights reserved. | Licensed & Insured | Emergency Service Available</p>
              <p className="mt-2 text-sm">Licensed Plumbing Contractor | Serving Kane County</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
} 